module.exports = __webpack_public_path__ + "static/background-mini-06e0915b7c47cedf7750020ef3396306.jpg";